// Shared Indian-mobile helpers — single source of truth for client-side phone
// handling (mirrors the server rule in api/src/lib/phone.js).

// Reduce any pasted/typed value to the 10-digit local number: strip non-digits,
// drop a leading 91 (12 digits) or 0 (11 digits), then cap at 10 so a 91 prefix
// never eats the real digits.
export function sanitizePhone(value) {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, 10);
}

// Valid Indian mobile: exactly 10 digits starting 6-9.
export function isValidPhone(value) {
  return /^[6-9]\d{9}$/.test(sanitizePhone(value));
}
